import { render, staticRenderFns } from "./GatewayConfig.vue?vue&type=template&id=d5afedc8&scoped=true"
import script from "./GatewayConfig.vue?vue&type=script&lang=js"
export * from "./GatewayConfig.vue?vue&type=script&lang=js"
import style0 from "./GatewayConfig.vue?vue&type=style&index=0&id=d5afedc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5afedc8",
  null
  
)

export default component.exports